let crowdfundingModalValidator;

$(function () {
    $('.js-crowdfunding-add').on('click', function (e) {
        const $holder = $(this).closest('.js-crowdfunding-holder'),
            selectedColor = $holder.find('.js-crowdfunding-select').val(),
            $errorMessage = $holder.siblings('.js-crowdfunding-add-error');

        e.preventDefault();

        $errorMessage.slideUp(150);

        if (!selectedColor && false) {
            $errorMessage.stop(true, false).slideDown(150);

            return false;
        }

        $('.js-crowdfunding-modal-form').find('input[name="product_color"]').val(selectedColor);

        $('#crowdfunding-modal').modal('show');
    });

    crowdfundingModalValidator = $('.js-crowdfunding-modal-form').validate({
        errorPlacement: function (error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            const $submit = $('.js-crowdfunding-modal-submit'),
                $error = $('.js-crowdfunding-modal-error'),
                $success = $('.js-crowdfunding-modal-success'),
                $hide = $('.js-crowdfunding-modal-hide');

            $submit.prop('disabled', true).addClass('is-loading');
            $error.slideUp(150);

            Form.ajaxPost(form, function (data) {
                $submit.prop('disabled', false).removeClass('is-loading');

                if (data.status) {
                    $hide.slideUp(250);
                    $success.slideDown(250).addClass('is-active');
                } else {
                    $error.html(data.message).slideDown(250);
                }
            }, 'json');
        }
    });

    $('#crowdfunding-modal').on('hide.bs.modal', function () {
        crowdfundingModalValidator.resetForm();
    });

    $('#crowdfunding-modal').on('show.bs.modal', function () {
        if ($('.js-crowdfunding-modal-success').hasClass('is-active')) {
            const $error = $('.js-crowdfunding-modal-error'),
                $success = $('.js-crowdfunding-modal-success'),
                $hide = $('.js-crowdfunding-modal-hide');

            $success.removeClass('is-active')

            $error.slideUp(0);
            $success.slideUp(0);
            $hide.slideDown(0);

            $.each(['name', 'email', 'phone'], function () {
                $('.js-crowdfunding-modal-form').find(`input[name="${this}"]`).val('');
            });

            $('.js-crowdfunding-modal-consents').find('input[type="checkbox"]').each(function () {
                $(this).prop('checked', false);
            });
        }
    });
});